export const lwWatchMouse = (Vue, PluginOptions = {}) => {

  Vue.directive("lwWatchMouse", {
    componentUpdated: function (el, binding, vnode) {
      let watchMouse = (e) => {
        console.log("---")
        if (!el.contains(e.target) || (el.contains(e.target) && !binding.value.f)) {
          document.documentElement.removeEventListener('click', watchMouse);
          binding.value.f = false;
        }
      };
      if (binding.value.f) {
        document.documentElement.addEventListener('click', watchMouse)
      }
    }
  });
};
